module.exports = __webpack_public_path__ + "static/media/footerMobile.f981a27d.png";